import {
    Box,
    Button,
    Card,
    Grid,
    Typography
} from "@mui/material";
import {useNavigate} from "react-router-dom";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';


export default function SelectForm() {
    const navigate = useNavigate();


    const handleClick = (form) => {
        localStorage.setItem('form_type', form); // Almacenar en localStorage
        navigate(`/app/contact`, { state: { formType: form } }); // Pasar como parámetro de navegación
    };

    return (
        <Box>
            <Box pt={8} pb={8}>
                <Grid container justifyContent="center" sx={{ my: 10 }}>
                    <Grid item xs={12} lg={8}>
                        <Card>
                            <Box p={2}>
                                <Typography variant="h4" align="center">Seleccione el formulario</Typography>
                                <Typography variant="body2" align="center">Selecciona el formulario a usar</Typography>
                                <Box>
                                    
                                    <Box mt={3} width="100%" display="flex" justifyContent="space-evenly">
                                        <Box>
                                            <Button variant="contained" color="primary" fullWidth  
                                            sx={{
                                                minWidth: 'auto',
                                                width: '150px',
                                                height: '150px',
                                                padding: '8px 0',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}    
                                            onClick={() => handleClick('miembros')}
                                            >
                                                <PersonOutlineOutlinedIcon sx={{ fontSize: 60 }} />
                                                Miembros</Button>
                                        </Box>
                                        <Box>
                                            <Button variant="contained" color="primary" fullWidth 
                                                sx={{
                                                    minWidth: 'auto',
                                                    width: '150px',
                                                    height: '150px',
                                                    padding: '8px 0',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                                onClick={() => handleClick('obreros')}
                                            >
                                                <EngineeringOutlinedIcon sx={{ fontSize: 60 }} />
                                                Obreros</Button>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
}